import { AuthUseCase, PasswordResetUseCase } from "@app/auth";
import { API } from "@infra/implementations/api";
import { browserTokenStore } from "@infra/implementations/storage/browserTokenStore";
import { browserImpersonationStore } from "@infra/implementations/storage/impersonationStore";

/**
 * Browser composition of the auth use cases. Constructed once at app startup
 * and provided to the React tree via `UseCasesProvider`. A CLI build would
 * have its own composition module that builds the same use cases with
 * Node-friendly adapters.
 *
 * `API.Users` (the legacy `UsersAPI` class) implements the `IUsers` port
 * directly — no adapter shim needed.
 */
export const authUseCase = new AuthUseCase({
	userApi: API.Users,
	tokenStore: browserTokenStore,
	impersonationStore: browserImpersonationStore,
});

export const passwordResetUseCase = new PasswordResetUseCase({
	userApi: API.Users,
});
